export var getPriceRangeSettings = function (siteStore) {
    return {
        showPriceRange: siteStore.priceSettings.showPriceRange,
    };
};
//# sourceMappingURL=getPriceRangeSettings.js.map